export const trackingActions = {
  EXTERNAL_CAMERA_HELP: 'external-camera-help',
  PRE_RECORDED_HELP: 'pre-recorded-help',
  STREAM_KEY: 'stream-key',
  STREAM_SERVER: 'stream-server',
  TOGGLE_ADD_PRODUCT_VERSION: 'toggle-add-product-version',
  PRODUCT_VERSION: 'product-version',
  PRODUCT: 'product',
  PREVIEW_PRE_RECORDED: 'preview-pre-recorded',
  UPLOAD_PRE_RECORDED: 'upload-pre-recorded',
  VIDEO_SOURCE: 'video-source',
  TEST_PRODUCT_URL: 'test-product-url',
  CONTENT_FOUND_HELP: 'content-found-help',
  SOME_CONTENT_FOUND_HELP: 'some-content-found-help',
  NO_CONTENT_FOUND_HELP: 'no-content-found-help',
  API_KEY: 'api-key',
  API_KEY_MENU: 'api-key-menu',
  DELETE_PRODUCT_CONFIRMATION_MODAL: 'delete-product-confirmation-modal',
  DELETE_PRODUCT_VERSION_CONFIRMATION_MODAL: 'delete-product-version-confirmation-modal',
  PRODUCT_MANUALLY: 'product-manually',
  PRE_RECORDED_PROCESSING_FAILED_ALERT: 'pre-recorded-processing-failed-alert',
  DATA_EXPORT_JOB: 'data-export-job',
};

export const trackingMetaActions = {
  ADD: 'add',
  COPY: 'copy',
  CREATE: 'create',
  DELETE: 'delete',
  VIEW: 'view',
  BAMBUSER_LIVESHOPPING_APP: 'bambuser-liveShopping-app',
  EXTERNAL_CAMERA: 'external-camera',
  PRE_RECORDED: 'pre-recorded',
  SUBMIT: 'submit',
  CLICK: 'click',
  EDIT: 'edit',
  OPEN: 'open',
  CLOSE: 'close',
  UPLOAD: 'upload',
  UPSELL: 'upsell',
};
